<template>
    <div v-wechat-title="this.title">
        <van-sticky :offset-top="0">
            <div class="page_top">
                <div class="date_choose">
                    <i class="icon iconfont iconarrow-left-filling" @click="subtractDate"></i>
                    <span class="date_info" @click="chooseCheckDay">{{date || '请选择'}}</span>
                    <i class="icon iconfont iconarrow-right-filling" @click="addDate"></i>
                </div>
                <van-search class="search_div" input-align="center" background="#F8F7FC" @search="reLoad" v-model="keyword" placeholder="患者姓名或手机号" />
            </div>
        </van-sticky>


        <van-calendar v-model="showCalendar" :default-date="defaultDate" :min-date="minDate" :show-confirm="false" @confirm="onConfirmCalendar" />

        <van-dialog
                v-model="showBedPopup"
                :show-confirm-button="false"
                :close-on-click-overlay="true"
                class="bed-dialog">
            <template #title>
                <div class="dialog-title">
                    <span>安排床位</span>
                    <span class="close-icon" @click="showBedPopup = false">✕</span>
                </div>
            </template>
            <div class="bed-popup">
                <div class="patient-info-section" v-if="currentPatient" style="display: flex;align-items: center;justify-content: space-between;">
                    <div class="patient-header">{{currentPatient.name}}</div>
                    <div class="patient-detail">{{currentPatient.sex}} {{currentPatient.age}}</div>
                </div>
                <div class="bed-section">
                    <div class="bed-list">
                        <div
                                v-for="bed in bedList"
                                :key="bed.room_id"
                                class="bed-item"
                                :class="{
                                    'bed-occupied': bed.use_count > 0  && (bed.user_id != currentPatient.userid || bed.customer_id != currentPatient.customerid),
                                    'bed-available': bed.use_count <= 0 || (bed.use_count > 0 && bed.user_id == currentPatient.userid && bed.customer_id == currentPatient.customerid),
                                    'bed-selected': selectedBed?.room_id == bed.room_id
                                }"
                                @click="selectBed(bed)">
                          <div v-if="bed.room_id != -1" style="text-align: center">
                            <div>{{ bed.room_name }}</div>
                          </div>
                          <div v-else class="freeRoom">
                            <span>{{ bed.room_name }}</span>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="confirm-section">
                    <div class="confirm-btn" @click="confirmAssignBed">确认安排</div>
                </div>
            </div>
        </van-dialog>

        <van-dialog
                v-model="showWaitDoctorConfirmDialog"
                :show-confirm-button="false"
                :close-on-click-overlay="false"
                class="wait-doctor-confirm-dialog">
            <template #title>
                <div class="wait-doctor-confirm-title">提示</div>
            </template>
            <div class="wait-doctor-confirm-content">
                项目主执行人与当前登录账户不一致，请确认
            </div>
            <div class="wait-doctor-confirm-actions">
                <van-button
                        class="wait-doctor-confirm-btn"
                        size="small"
                        @click="closeWaitDoctorConfirmDialog">
                    返回
                </van-button>
                <van-button
                        class="wait-doctor-confirm-btn"
                        type="primary"
                        color="#CF8C57"
                        size="small"
                        @click="confirmWaitDoctorStart(0)">
                    继续执行
                </van-button>
                <van-button
                        class="wait-doctor-confirm-btn"
                        type="primary"
                        color="#CF8C57"
                        size="small"
                        @click="confirmWaitDoctorStart(1)">
                    修改为当前人并执行
                </van-button>
            </div>
        </van-dialog>

        <van-tabs
                v-model="qrystatus" :offset-top="62"
                @change="changeTab" class="status_div"
                color="#E69F12"
                title-active-color="#E69F12"
                sticky>

            <van-tab title="待分诊" name="5" :badge="waitTriage" >
              <van-pull-refresh v-model="refreshing5" @refresh="onRefresh('5')" style="background: #f9f9f9">
                <div class="treat_main_list" :class="{'bai': count5 <= 0}">

                    <div
                        class="has_no_data"
                        v-if="!loading5 && finished5 && list5.length === 0">
                      当天无理疗数据
                    </div>

                    <van-list
                            v-else
                            v-model="loading5"
                            :finished="finished5"
                            @load="onLoad"
                            :offset="30"
                            :immediate-check="false"
                            finished-text="加载完成">
                        <template #loading v-if="refreshing5">
                          <div></div>
                        </template>

                        <div class="one"  v-for="item in list5" :key="item.serviceid">
                            <div class="name_appointment">
                                <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                                <div class="right">
                                  <div @click="openBedPopup(item)" v-if="item.projectname"
                                       style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                    <van-icon name="edit"/>
                                    {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                  </div>
                                </div>
                            </div>
                            <div class="sex_age_phone" style="padding-bottom: 0; ">
                            </div>
                            <div class="title_top">
                                <div class="left" style="font-weight:bold;font-size:0.4rem;width: auto" v-if="item.projectname">
                                    <span v-for="(project, index) in item.projectname.split(',')" :key="index">
                                        <span v-if="index > 0">、</span>
                                        {{ project }}
                                    </span>
                                </div>
                            </div>
                            <div style="display: flex;justify-content: flex-end;align-items: center;gap: 15px">
                                <div @click="cancelProject(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">取消执行</div>

                                <div v-if="!item.signaturetime" @click="goAllSignature(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">去签名</div>

                                <div @click="goAssignTreat(item,'1')"
                                    style="background-color: #CF8C57;text-align: center;color: #fff;border-radius: 10px;font-size:0.36rem;padding:5px 15px">
                                  分诊
                                </div>
                            </div>
                        </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab title="待执行" name="2" :badge="wait" >
              <van-pull-refresh v-model="refreshing2" @refresh="onRefresh('2')" style="background: #f9f9f9">
                <div class="treat_main_list" :class="{'bai': count2 <= 0}" >
                  <div
                      class="has_no_data"
                      v-if="!loading2 && finished2 && list2.length === 0">
                    当天无理疗数据
                  </div>

                    <van-list
                            v-else
                            v-model="loading2"
                            :finished="finished2"
                            @load="onLoad"
                            :offset="30"
                            :immediate-check="false"
                            finished-text="加载完成">
                        <template #loading v-if="refreshing2">
                          <div></div>
                        </template>
                        <div
                            class="one wait-patient-card"
                            v-for="patient in list2"
                            :key="getWaitPatientKey(patient)">
                            <div class="wait-patient-head">
                              <div class="wait-patient-name">
                                <label v-if="patient.rankicon">{{ patient.rankicon }}</label>{{patient.name}}
                              </div>
                              <div class="wait-patient-bed" @click="openWaitBedPopup(patient)">
                                <van-icon name="edit"/>
                                {{ getWaitPatientRoomText(patient) }}
                              </div>
                              <div class="wait-time" @click="toggleWaitPatient(patient)">
                                {{ getWaitMinutesText(patient) }}
                                <van-icon :name="isWaitPatientExpanded(patient) ? 'arrow-up' : 'arrow-down'"/>
                              </div>
                            </div>

                            <template v-if="!isWaitPatientExpanded(patient)">
                              <div
                                  class="wait-project-row"
                                  v-for="project in getWaitProjectList(patient)"
                                  :key="project.serviceid">
                                <div class="wait-project-name">{{project.projectname}}</div>
                                <van-button
                                    type="primary"
                                    color="#CF8C57"
                                    class="wait-start-btn"
                                    size="small"
                                    @click="startWaitProject(project)">
                                  开始治疗
                                </van-button>
                              </div>
                            </template>

                            <template v-else>
                              <div
                                  class="wait-project-detail"
                                  v-for="project in getWaitProjectList(patient)"
                                  :key="project.serviceid">
                                <div class="wait-detail-title">
                                  <div class="wait-project-name">{{project.projectname}}</div>
                                  <div class="wait-doctor-name" v-if="getWaitProjectDoctor(project)">
                                    <span class="main-tag" v-if="getWaitProjectDoctor(project).ismain == 1">主</span>
                                    {{ getWaitProjectDoctor(project).dispname }}
                                  </div>
                                </div>
                                <div class="wait-acupoint-row">
                                  <span class="wait-acupoint-label">配穴：</span>
                                  <textarea
                                      class="wait-acupoint-textarea"
                                      :class="{'wait-acupoint-textarea-active': isWaitAcupointFocused(project)}"
                                      v-model="project.waitAcupointText"
                                      maxlength="500"
                                      @focus="setWaitAcupointFocus(project)"
                                      placeholder="请输入内容"></textarea>
                                </div>
                                <div class="wait-detail-actions">
                                  <div class="wait-link-btn" @click="detailCtrl(project.serviceid)">详情</div>
                                  <van-button
                                      type="primary"
                                      color="#CF8C57"
                                      class="wait-save-btn"
                                      size="small"
                                      @click="saveWaitAcupointPlan(project)">
                                    保存配穴方案
                                  </van-button>
                                  <van-button
                                      type="primary"
                                      color="#CF8C57"
                                      class="wait-start-btn"
                                      size="small"
                                      @click="startWaitProject(project)">
                                    开始治疗
                                  </van-button>
                                </div>
                              </div>

                              <div class="wait-patient-actions">
                                <div class="wait-link-btn" @click="goWaitPatientAssignTreat(patient)">加项目</div>
                                <div class="wait-link-btn" v-if="hasWaitUnsignedProject(patient)" @click="goAllSignature(getFirstWaitUnsignedProject(patient))">去签名</div>
                                <van-button
                                    type="primary"
                                    color="#CF8C57"
                                    class="wait-start-btn"
                                    size="small"
                                    @click="startAllWaitProject(patient)">
                                  全部开始
                                </van-button>
                              </div>
                            </template>
                        </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab  title="执行中" name="3" :badge="execute">
              <van-pull-refresh v-model="refreshing3" @refresh="onRefresh('3')" style="background: #f9f9f9">
                <div class="treat_main_list" :class="{'bai': count3 <= 0}">
                    <div
                        class="has_no_data"
                        v-if="!loading3 && finished3 && list3.length === 0">
                      当天无理疗数据
                    </div>

                    <van-list
                        v-else
                        v-model="loading3"
                        :finished="finished3"
                        @load="onLoad"
                        :offset="30"
                        :immediate-check="false"
                        finished-text="加载完成">
                      <template #loading v-if="refreshing3">
                        <div></div>
                      </template>
                      <div class="one"  v-for="item in list3" :key="item.serviceid">
                        <div class="name_appointment">
                          <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                          <div class="right">
                            <span @click="openBedPopup(item)"
                                  style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                    <van-icon name="edit"/>
                                    {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                            </span>
                          </div>
                        </div>
                        <div class="sex_age_phone" style="padding-bottom: 0; ">
                        </div>
                        <div class="title_top">
                          <div class="left" style="font-weight:bold;font-size:0.4rem;width: auto">{{item.projectname}}</div>
                        </div>
                        <div
                            class="title_top execute-doctor-row"
                            v-for="(doctor, index) in item.doctorlist"
                            style="align-items: flex-start;"
                            :key="index"
                        >
                          <div class="left doctor-left">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            {{ doctor.dispname }}
                            <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                    ({{ doctor.pointlist.join(',') }})
                                  </span>
                          </div>
                          <div class="right doctor-right execute-status-btn" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                            <div class="time">
                              {{ formatTime(doctor, item) }}
                            </div>
                            <div class="status-text">
                              {{ formatStatus(doctor) }}
                            </div>
                          </div>
                        </div>

                        <div style="display: flex;justify-content: flex-end;gap: 15px;align-items: center">
                          <div @click="detailCtrl(item.serviceid)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">详情</div>
                          <div @click="restartExec(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">重新开始</div>
                          <div @click="goAssignTreat(item,'2')" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">加项目</div>

                          <div v-if="!item.signaturetime" @click="searchList(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">去签名</div>

                          <div class="acupoint-assign-btn" @click="openAcupointDialog(item)">
                            配穴分工
                          </div>
                        </div>
                      </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab  title="已完成" name="4" :badge="finish" >
              <van-pull-refresh v-model="refreshing4" @refresh="onRefresh('4')" style="background: #f9f9f9">
                <div class="treat_main_list" :class="{'bai': count4 <= 0}">
                    <div
                        class="has_no_data"
                        v-if="!loading4 && finished4 && list4.length === 0">
                      当天无理疗数据
                    </div>
                    <van-list
                        v-else
                        v-model="loading4"
                        :finished="finished4"
                        @load="onLoad"
                        :offset="30"
                        :immediate-check="false"
                        finished-text="加载完成">
                      <template #loading v-if="refreshing4">
                        <div></div>
                      </template>
                      <div class="one"  v-for="item in list4" :key="item.serviceid">
                        <div class="name_appointment">
                          <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                          <div class="right">
                            <span style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                               {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                            </span>
                          </div>
                        </div>
                        <div class="sex_age_phone" style="padding-bottom: 0; ">
                        </div>
                        <div class="title_top title_top_text">
                          <div class="left" style="font-weight:bold;font-size:0.4rem;width: auto">{{item.projectname}}</div>
                        </div>
                        <div
                            class="title_top"
                            style="align-items: flex-start;"
                            v-for="(doctor, index) in item.doctorlist"
                            :key="index"
                        >
                          <div class="left doctor-left">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            {{ doctor.dispname }}
                            <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                      ({{ doctor.pointlist.join(',') }})
                                    </span>
                          </div>
                          <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                            <div class="time">
                              {{ formatTime(doctor, item) }}
                            </div>
                            <div class="status-text">
                              {{ formatStatus(doctor) }}
                            </div>
                          </div>
                        </div>

                        <div style="display: flex;justify-content: flex-end;gap: 15px;align-items: center">
                          <div @click="detailCtrl(item.serviceid)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">详情</div>
                          <div @click="goAssignTreat(item,'2')" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;">加项目</div>

                          <div @click="openAcupointDialog(item)"
                               style="background-color: #CF8C57;text-align: center;color: #fff;border-radius: 6px;font-size:0.36rem;padding:5px 12px">
                            配穴分工
                          </div>
                        </div>
                      </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>
        </van-tabs>

        <div class="btnimg" @click="$router.push({path:'/triage'})">
            <img src="@/assets/btn.png" alt="">
        </div>

        <acupoint-allocation
            :visible="showAcupointDialog"
            :qryType="2"
            :uname="uname"
            :usex="usex"
            :uage="uage"
            :uphone="uphone"
            :userId="Number(currentUserId)"
            :customerId="Number(currentCustomerId)"
            :tCode="currenttCode"
            :serviceId="currentServiceId"
            :qrydate="date"
            :currentallpoints="currentAllPoints"
            :currentAcupointData="currentAcupointData"
            :hide-add-doctor-button="hideAcupointAddDoctorButton"
            @update:visible="handleAcupointDialogVisibleChange"
            @plan-save="handleAcupointPlanSave"
            @save="handleAcupointSave"
        />
    </div>
</template>

<script>
import axios from 'axios'
import {
  wxtreatstatistics,
  wxtreatqry,
  wxqryfreeroom,
  wxsaveroom,
  wxoprtreat,
  waitsignaturelist,
  wxtreatopr,wxrestarttreat,
  wxsaveassignacupoint
} from '@/api/medical'
    import { mapGetters } from 'vuex'
    // import Vue from 'vue';
    import { Toast,Dialog } from 'vant';
    import Vue from 'vue';
    import { Calendar } from 'vant';
    import AcupointAllocation from "@/view/acupointAllocation/index.vue";
    import { getServerNow } from '@/utils/time'

    Vue.use(Calendar);

    const DEFAULT_QRY_STATUS = '5'
    const TREAT_WAIT_SCROLL_TO_BOTTOM = 'TREAT_WAIT_SCROLL_TO_BOTTOM'
    const QRY_STATUS_CONFIG = {
      '5': {
        loading: 'loading5',
        finished: 'finished5',
        count: 'count5',
        page: 'page5',
        list: 'list5',
        isload: 'isload5',
        refreshing: 'refreshing5'
      },
      '2': {
        loading: 'loading2',
        finished: 'finished2',
        count: 'count2',
        page: 'page2',
        list: 'list2',
        isload: 'isload2',
        refreshing: 'refreshing2'
      },
      '3': {
        loading: 'loading3',
        finished: 'finished3',
        count: 'count3',
        page: 'page3',
        list: 'list3',
        isload: 'isload3',
        refreshing: 'refreshing3'
      },
      '4': {
        loading: 'loading4',
        finished: 'finished4',
        count: 'count4',
        page: 'page4',
        list: 'list4',
        isload: 'isload4',
        refreshing: 'refreshing4'
      }
    }

    export default {
      components: {AcupointAllocation},
        computed: {
            ...mapGetters([
                'username','clinicid','isrefresh','isclose','clinicname'
            ]),
        },
        data() {
            return {
                qrystatus: DEFAULT_QRY_STATUS,
                oldQrystatus: DEFAULT_QRY_STATUS,
                list5: [],
                loading5: false,
                finished5: false,
                count5: 0,
                page5: 1,
                isload5: false,
                refreshing5: false,

                list2: [],
                // 无限加载
                loading2: false,
                finished2: false,
                count2: 0,
                page2: 1,
                isload2: false,
                refreshing2: false,

                list3: [],
                // 无限加载
                loading3: false,
                finished3: false,
                count3: 0,
                page3: 1,
                isload3: false,
                refreshing3: false,

                list4: [],
                // 无限加载
                loading4: false,
                finished4: false,
                count4: 0,
                page4: 1,
                isload4: false,
                refreshing4: false,
                keyword: '',
                waitTriage: 0,
                wait: 0,
                execute: 0,
                finish:0,
                minDate: new Date(2020, 0, 1),
                defaultDate: new Date(),
                date:'',
                showCalendar:false,
                title:'理疗工作台',
                loading: false,
                loadingStatus: '',
                loadRequestNo: 0,
                loadCancelSource: null,
                showBedPopup: false,
                bedList: [],
                selectedBed: null,
                currentPatient: null,
                showWaitDoctorConfirmDialog: false,
                waitDoctorConfirmAction: null,

                showAcupointDialog:false,
                uname:null,
                usex:null,
                uphone:null,
                uage:null,
                currentAllPoints:null,
                currentAcupointData:[],
                currentItemRef: null,
                currentServiceId: null,
                currentUserId: null,
                currentCustomerId: null,
                currenttCode: null,
                hideAcupointAddDoctorButton: false,
                acupointDialogNeedRefresh: false,

                timer: null,
                expandedWaitPatientKey: '',
                focusedWaitAcupointServiceId: '',
                signaturelist:[],
                autoLoadWaitToEnd: false,
                wechatBackHandler: null
            }
        },
        mounted () {
            this.$store.dispatch('changeIsClose', '1')
            this.$store.dispatch('changeNav', '0')
            this.$store.dispatch('hideOrShowNav', false)
            this.getCurDate()

            this.restoreTreatPageTab()
            this.initWechatBackToHome()


            this.startTimer()
            this.setListLoading(this.qrystatus, true)
            this.onLoad()
        },
        beforeDestroy() {
          this.stopTimer()
          this.removeWechatBackToHome()
          // 离开页面时取消待返回的列表请求，避免缓存页销毁后继续回写状态。
          this.cancelLoadRequest()
          this.loadRequestNo = this.loadRequestNo + 1
        },
        activated() {
            this.startTimer()
            this.$store.dispatch('changeNav', '0')
            this.$store.dispatch('hideOrShowNav', false)
            this.restoreTreatPageTab()
            this.initWechatBackToHome()
            console.log(this.isrefresh, '----isrefresh')
            if(this.isrefresh == '1' && !this.loading) {
                this.$store.dispatch('changeIsRefresh', '0')
                this.onRefresh(this.qrystatus)
            }
        },
        deactivated() {
          this.stopTimer()
          this.removeWechatBackToHome()
        },
        beforeRouteLeave(to, from, next) {
            console.log(to,from,'treat-----')
            if(to.path == '/assignTreat'){
                from.meta.keepAlive = true

            }else if(to.path == '/triage'){
                to.meta.keepAlive = false
            }
            next()
        },
        methods: {
            /**
             * 初始化微信网页左上角返回监听，使理疗工作台返回时统一回到首页。
             */
            initWechatBackToHome() {
                if (typeof window === 'undefined' || !window.history || !window.addEventListener) {
                    return
                }

                this.removeWechatBackToHome()

                const currentState = window.history.state || {}
                if (!currentState.treatBackToHome) {
                    window.history.pushState(
                        Object.assign({}, currentState, { treatBackToHome: true }),
                        document.title,
                        window.location.href
                    )
                }

                this.wechatBackHandler = () => {
                    this.removeWechatBackToHome()
                    this.$router.replace('/')
                }
                window.addEventListener('popstate', this.wechatBackHandler)
            },
            /**
             * 移除微信返回监听，避免页面缓存失活后影响其他页面返回逻辑。
             */
            removeWechatBackToHome() {
                if (this.wechatBackHandler && typeof window !== 'undefined' && window.removeEventListener) {
                    window.removeEventListener('popstate', this.wechatBackHandler)
                    this.wechatBackHandler = null
                }
            },
            goBack() {
                window.WeixinJSBridge.call('closeWindow')
            },
            getCurDate() {
                const nowDate = new Date();
                this.formatDate(nowDate)
            },
            addDate() {
                var d = new Date(this.date);
                d.setDate(d.getDate() + 1);
                this.formatDate(d)
                this.reLoad()
            },
            subtractDate() {
                var d = new Date(this.date);
                d.setDate(d.getDate() - 1);
                this.formatDate(d)
                this.reLoad()
            },
            formatDate(d) {
                const curDate = {
                    year: d.getFullYear(),
                    month: d.getMonth() + 1,
                    date: d.getDate(),
                }
                const newmonth = curDate.month>=10?curDate.month:'0'+curDate.month
                const day = curDate.date>=10?curDate.date:'0'+curDate.date
                this.date = curDate.year + '-' + newmonth + '-' + day
                this.defaultDate = new Date(this.date);
            },
            chooseCheckDay(){
                this.showCalendar = true
            },
            onConfirmCalendar(date){
                this.showCalendar = false
                this.formatDate(date);

                this.reLoad()
            },

            changeTab(name){
              const status = this.getValidQryStatus(name)
              if (this.loading && this.loadingStatus === status) {
                Toast('数据加载中，请稍后再切换')

                this.$nextTick(() => {
                  this.qrystatus = this.oldQrystatus
                })

                return
              }

              this.oldQrystatus = status
              this.qrystatus = status

              this.resetCurrentTab(status)

              this.setListLoading(status, true)
              this.onLoad()
            },
            setListLoading(status, value) {
              const config = this.getTabConfig(status)
              this[config.loading] = value
            },
            /**
             * 获取页面支持的查询状态，非法状态统一回到待分诊。
             */
            getValidQryStatus(status) {
              const validStatus = status + ''
              return QRY_STATUS_CONFIG[validStatus] ? validStatus : DEFAULT_QRY_STATUS
            },
            /**
             * 获取指定状态对应的列表字段配置。
             */
            getTabConfig(status) {
              return QRY_STATUS_CONFIG[this.getValidQryStatus(status)]
            },
            /**
             * 判断指定状态的列表是否已经加载完成。
             */
            isTabFinished(status) {
              const config = this.getTabConfig(status)
              return this[config.finished]
            },
            /**
             * 获取指定状态当前要查询的页码。
             */
            getTabPage(status) {
              const config = this.getTabConfig(status)
              return this[config.page]
            },
            /**
             * 解析接口返回的数量字段，避免空值变成 NaN。
             */
            parseCount(value) {
              const count = parseInt(value || 0)
              return isNaN(count) ? 0 : count
            },
            /**
             * 判断待执行列表加载完成后是否需要自动滚动到底部。
             */
            isWaitScrollToBottom() {
              return sessionStorage.getItem(TREAT_WAIT_SCROLL_TO_BOTTOM) === '1'
            },
            /**
             * 清理待执行列表自动滚动到底部标记，避免影响后续普通返回。
             */
            clearWaitScrollToBottomFlag() {
              sessionStorage.removeItem(TREAT_WAIT_SCROLL_TO_BOTTOM)
            },
            /**
             * 待执行列表渲染完成后滚动到页面底部。
             */
            scrollWaitListToBottom() {
              this.$nextTick(() => {
                setTimeout(() => {
                  const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0
                  window.scrollTo(0, scrollHeight)
                  document.documentElement.scrollTop = scrollHeight
                  document.body.scrollTop = scrollHeight
                }, 50)
              })
            },
            /**
             * 取消当前未完成的列表请求。
             */
            cancelLoadRequest() {
              if (this.loadCancelSource) {
                this.loadCancelSource.cancel('cancel treatPage pending request')
                this.loadCancelSource = null
              }
            },
            /**
             * 创建本次列表加载上下文，并在新请求开始前取消旧请求。
             */
            createLoadContext(status) {
              this.cancelLoadRequest()
              this.loadRequestNo = this.loadRequestNo + 1

              const source = axios.CancelToken.source()
              this.loadCancelSource = source

              return {
                requestNo: this.loadRequestNo,
                status: status,
                cancelToken: source.token
              }
            },
            /**
             * 判断接口回调是否仍属于当前页面的最新请求。
             */
            isCurrentLoadContext(loadContext) {
              return loadContext
                  && loadContext.requestNo === this.loadRequestNo
                  && loadContext.status === this.qrystatus
            },
            /**
             * 结束当前列表加载状态。
             */
            finishLoadContext(loadContext) {
              if (!this.isCurrentLoadContext(loadContext)) {
                return
              }

              this.setListLoading(loadContext.status, false)
              this.setRefreshing(loadContext.status, false)
              this.loading = false
              this.loadingStatus = ''
              this.loadCancelSource = null
            },
            /**
             * 按统计数量变化重置已经加载过的页签。
             */
            resetLoadedTabWhenCountChanged(status, newCount, oldCount) {
              const config = this.getTabConfig(status)
              if (this[config.isload] && newCount !== oldCount) {
                // 统计数量变化时重置对应页签，避免继续展示旧分页数据。
                this.resetCurrentTab(status)
              }
            },
            /**
             * 处理理疗工作台统计接口返回值。
             */
            handleStatisticsResponse(response, resetLoadedTab) {
              if (!response.response_body) {
                return
              }

              if (resetLoadedTab === undefined) {
                resetLoadedTab = true
              }

              const oldWaitTriage = this.waitTriage
              const oldWait = this.wait
              const oldExecute = this.execute
              const oldFinish = this.finish

              this.waitTriage = this.parseCount(response.response_body.waitTriage)
              this.wait = this.parseCount(response.response_body.wait)
              this.execute = this.parseCount(response.response_body.execute)
              this.finish = this.parseCount(response.response_body.finish)

              if (!resetLoadedTab) {
                return
              }

              this.resetLoadedTabWhenCountChanged('5', this.waitTriage, oldWaitTriage)
              this.resetLoadedTabWhenCountChanged('2', this.wait, oldWait)
              this.resetLoadedTabWhenCountChanged('3', this.execute, oldExecute)
              this.resetLoadedTabWhenCountChanged('4', this.finish, oldFinish)
            },
            /**
             * 处理理疗工作台列表接口返回值。
             */
            handleTreatQryResponse(status, response) {
              const config = this.getTabConfig(status)
              this[config.isload] = true

              if (response.response_body && response.response_body.list) {
                const pages = this.parseCount(response.response_body.pages)
                const list = status === '2'
                    ? this.normalizeWaitPatientList(response.response_body.list)
                    : response.response_body.list
                this[config.count] = this.parseCount(response.response_body.num)
                this[config.list] = this[config.list].concat(list)
                this[config.finished] = pages <= 0 || this[config.page] >= pages
                this[config.page] = this.parseCount(this[config.page]) + 1
                return
              }

              // 没有列表数据时也要结束加载，避免 van-list 继续触发 load。
              this[config.finished] = true
            },
            /**
             * 检查是否需要将待执行列表自动加载到最后并展开最后一项。
             */
            handleWaitAutoLoadToEnd() {
              if (!this.autoLoadWaitToEnd || this.qrystatus !== '2') {
                return
              }

              if (!this.finished2) {
                this.onLoad()
                return
              }

              this.autoLoadWaitToEnd = false
              sessionStorage.removeItem('TREAT_WAIT_LOAD_TO_END')
              this.expandLastWaitPatient()
              if (this.isWaitScrollToBottom()) {
                this.scrollWaitListToBottom()
                this.clearWaitScrollToBottomFlag()
              }
            },
            reLoad(){
                // Manual reload should replace pending work for the current query condition.
                this.cancelLoadRequest()
                this.loading = false
                this.loadingStatus = ''

                Object.keys(QRY_STATUS_CONFIG).forEach(status => {
                  // 日期或关键字变化时重置所有页签，避免不同查询条件的数据混在一起。
                  this.resetCurrentTab(status)
                })
                this.onLoad()
            },
            /**
             * 只刷新理疗工作台统计信息，不触发列表数据重新查询。
             */
            reloadStatisticsOnly() {
                let sdata = {
                    username: this.username,
                    qrydate: this.date,
                    keyword: this.keyword,
                    clinicid: this.clinicid
                }

                wxtreatstatistics(sdata).then(response => {
                    // 开始治疗后的统计刷新不重置列表，避免刚本地移除的数据被清空。
                    this.handleStatisticsResponse(response, false)
                }).catch(() => {
                    // 统计刷新失败不回滚本地开始治疗结果，避免影响当前操作反馈。
                })
            },
            /**
             * 加载指定 tab 的指定页数据，供无限加载和返回恢复分页共同复用。
             */
            loadTreatPageData(status, qryPage) {
                const config = this.getTabConfig(status)
                this[config.page] = this.parseCount(qryPage) || 1
                this.loading = true
                this.loadingStatus = status
                this.setListLoading(status, true)
                // New load cancels pending request and marks older callbacks as stale.
                const loadContext = this.createLoadContext(status)
                const requestConfig = {
                    cancelToken: loadContext.cancelToken
                }

                let sdata = {
                    username: this.username,
                    qrydate: this.date,
                    keyword: this.keyword,
                    clinicid: this.clinicid
                }
                let data = {
                    username: this.username,
                    qrydate: this.date,
                    keyword: this.keyword,
                    page: this[config.page] + '',
                    qrystatus: status,
                    clinicid: this.clinicid
                }

                return Promise.all([
                    wxtreatstatistics(sdata, requestConfig),
                    wxtreatqry(data, requestConfig)
                ]).then(([statisticsResponse, qryResponse]) => {
                    if (!this.isCurrentLoadContext(loadContext)) {
                        return
                    }

                    // Statistics refresh must not reset the list page captured by this request.
                    this.handleStatisticsResponse(statisticsResponse, false)

                    if(Toast){
                        Toast.clear()
                    }

                    // Write list data only to the tab captured when this request started.
                    this.handleTreatQryResponse(status, qryResponse)
                }).catch(error => {
                    if (axios.isCancel(error) || !this.isCurrentLoadContext(loadContext)) {
                        return
                    }
                }).then(() => {
                    // Always release the newest active request; stale requests are ignored.
                    this.finishLoadContext(loadContext)
                })
            },
            onLoad(){
                const status = this.getValidQryStatus(this.qrystatus)
                if (this.qrystatus !== status) {
                  this.qrystatus = status
                  this.oldQrystatus = status
                }

                console.log(this.clinicid, '*****this.clinicid')
                if(this.clinicid == null || this.clinicid == '' || this.clinicid == undefined
                    || this.username == null || this.username == '' || this.username == undefined) {
                    Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: '未登录或未选择诊所，页面关闭',
                    });
                    let second = 1;
                    const timer = setInterval(() => {
                        second--;
                        if (!second) {
                            clearInterval(timer);
                            // 手动清除 Toast
                            Toast.clear();
                            this.goBack()
                        }
                    }, 1000);
                    // Login/clinic guard exits before requests, so release current list state.
                    this.setListLoading(status, false)
                    this.setRefreshing(status, false)
                    return;

                }
                if(this.isTabFinished(status)) {
                    this.setListLoading(status, false)
                    this.setRefreshing(status, false)
                    return
                }
                if (this.loading && this.loadingStatus === status) return

                return this.loadTreatPageData(status, this.getTabPage(status)).then(() => {
                    this.handleWaitAutoLoadToEnd()
                })


            },

            // 理疗详情
            detailCtrl(serviceid){
                this.$store.dispatch('changeIsRefresh', '0')
                this.$router.push({
                    path: '/treatDetail',
                    query: {
                        serviceid: serviceid,
                        qrydate: this.date
                    }
                })
            },
            openBedPopup(item) {
                this.currentPatient = item
                this.selectedBed = null
                this.bedList = []
                this.showBedPopup = true
                wxqryfreeroom({ clinicid: this.clinicid }).then(response => {
                    if (response.response_body && response.response_body.list) {
                        this.bedList = response.response_body.list
                        // 增加“无需床位”选项
                        this.bedList.push({
                          room_id: -1,
                          room_name: '无需床位',
                          use_count: 0
                        })

                        let defaultBed = null
                        if (item.roomid) {
                          defaultBed = this.bedList.find(
                              bed => bed.room_id == item.roomid
                          )
                        }

                        // 如果没有当前床位，则默认选中第一个空闲床位
                        if (!defaultBed) {
                          defaultBed = this.bedList.find(
                              bed => bed.use_count <= 0
                          )
                        }

                        // 设置默认选中
                        if (defaultBed) {
                          this.selectedBed = defaultBed
                        }
                    }
                })
            },
            selectBed(bed) {
                this.selectedBed = bed
            },

            /**
             * 判断床位是否为当前患者本人正在使用。
             */
            isCurrentPatientBed(bed) {
                if (!bed || bed.room_id == -1 || !this.currentPatient) {
                  return false
                }

                return bed.use_count > 0
                    && bed.user_id == this.currentPatient.userid
                    && bed.customer_id == this.currentPatient.customerid
            },

            /**
             * 判断床位是否已被其他患者占用。
             */
            isOtherPatientBed(bed) {
                if (!bed || bed.room_id == -1 || !this.currentPatient) {
                  return false
                }

                return bed.use_count > 0
                    && (bed.user_id != this.currentPatient.userid || bed.customer_id != this.currentPatient.customerid)
            },

            /**
             * 已占用床位确认安排前提示是否强制完成并安排。
             */
            showForceAssignBedDialog() {
                Dialog.confirm({
                  title: '提示',
                  message: '该床位的患者项目还没结束，是否强制完成并安排床位',
                  confirmButtonText: '确认安排',
                  cancelButtonText: '返回',
                  confirmButtonColor: '#CF8C57'
                }).then(() => {
                  this.confirmForceAssignBed()
                }).catch(() => {
                  // 点击返回，不做任何事
                })
            },

            /**
             * 强制完成占用床位患者的项目后，继续执行安排床位。
             */
            confirmForceAssignBed() {
                wxoprtreat({
                  oprType: 3,
                  doctor: this.username,
                  useUserId: this.selectedBed.user_id,
                  useCustomerId: this.selectedBed.customer_id,
                  iseditdoctor: 0
                }).then((response) => {
                  if (response.response_body.flag) {
                    this.saveAssignBed()
                  } else {
                    Toast.fail(response.response_body.msg)
                  }
                })
            },

            confirmAssignBed() {
                if (!this.selectedBed) {
                    Toast('请先选择床位')
                    return
                }

                if (this.isCurrentPatientBed(this.selectedBed)) {
                    this.saveAssignBed()
                    return
                }

                if (this.isOtherPatientBed(this.selectedBed)) {
                    if (this.selectedBed.is_all_executing == 0) {
                      Toast.fail('该床位存在未开始执行的项目，请选择其他床位')
                      return
                    }

                    this.showForceAssignBedDialog()
                    return
                }

                this.saveAssignBed()
            },

            /**
             * 保存正常床位安排。
             */
            saveAssignBed() {
                wxsaveroom({
                    roomId: this.selectedBed.room_id,
                    userId: this.currentPatient.userid,
                    customerId: this.currentPatient.customerid,
                    date: this.date,
                    username: this.username,
                    serviceid: this.currentPatient.allserviceid,
                    clinicid: this.clinicid
                }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success({
                          message: '安排床位成功',
                          duration: 1000
                        })
                        this.showBedPopup = false

                        this.$nextTick(() => {
                          // 待分诊安排床位成功后，按接口标记自动跳转分诊。
                          if (this.qrystatus == '5' && response.response_body.isjumppage){
                            this.goAssignTreat(this.currentPatient,'1')
                            return
                          }
                          this.reLoad()
                        })
                      }else{
                        Toast.fail(response.response_body.msg)
                      }
                })
            },

            openAcupointDialog(item) {
              this.currentItemRef = item
              this.uname = item.name
              this.uphone = item.phone
              this.usex = item.sex
              this.uage = item.age
              this.currentServiceId = item.serviceid
              this.currentAllPoints = item.allpoints
              this.currentAcupointData = item.doctorlist
              this.currentUserId = item.userid
              this.currentCustomerId = item.customerid
              this.currenttCode = item.projectcode
              this.hideAcupointAddDoctorButton = this.getValidQryStatus(this.qrystatus) === '4'
              this.acupointDialogNeedRefresh = false
              this.showAcupointDialog = true
            },

            // 状态文字
            formatStatus(doctor) {
              if (doctor.status == 0) return '开始治疗'
              if (doctor.status == 1) return '完成治疗'
              if (doctor.status == 2) return '已完成'
              return ''
            },

            // 时间显示
            formatTime(doctor) {
              if (doctor.status == 0) {
                return '--:--'
              }

              let seconds = 0

              // 已完成
              if (doctor.status == 2) {
                seconds = this.getSeconds(doctor.endtime) - this.getSeconds(doctor.starttime)
              }

              // 执行中（动态）
              if (doctor.status == 1) {
                seconds = Math.floor(getServerNow() / 1000) - this.getSeconds(doctor.starttime)
              }

              if (seconds < 0) seconds = 0

              const m = Math.floor(seconds / 60)
              const s = seconds % 60

              return `${this.pad(m)}:${this.pad(s)}`
            },

            // 时间转秒（兼容字符串）
            getSeconds(time) {
              if (!time) return 0

              const safeTime = time.replace(/-/g, '/')
              const timestamp = new Date(safeTime).getTime()
              if (isNaN(timestamp)) return 0

              return Math.floor(timestamp / 1000)
            },

            pad(num) {
              return num < 10 ? '0' + num : num
            },

            // 启动页面计时刷新，避免重复创建定时器。
            startTimer() {
              if (this.timer) {
                return
              }

              this.timer = setInterval(() => {
                // 触发视图更新（关键）
                this.$forceUpdate()
              }, 1000)
            },

            // 停止页面计时刷新，避免缓存页面在后台继续改写标题。
            stopTimer() {
              if (!this.timer) {
                return
              }

              clearInterval(this.timer)
              this.timer = null
            },

            getStatusClass(doctor) {
              if (doctor.status == 2) return 'status-finished'
              return 'status-active'
            },

            handleDoctorClick(doctor, item, refreshMode, iseditdoctor) {
              // 已完成不允许再点
              if (doctor.status == 2) return

              let oprtype = null
              if (doctor.status == 0) {
                oprtype = 1
              }

              if (doctor.status == 1) {
                oprtype = 2
              }

              wxoprtreat({
                serviceId: item.serviceid,
                treatId: doctor.treatid,
                oprType: oprtype,
                doctor: this.username,
                iseditdoctor: iseditdoctor == 1 ? 1 : 0
              }).then((response) => {
                if (response.response_body.flag) {
                  Toast.success('操作成功')

                  // 更新状态
                  doctor.status = oprtype

                  // 使用接口返回时间
                  if (oprtype == 1) {
                    doctor.starttime = response.response_body.startTime

                    if (refreshMode === 'waitStart') {
                      this.removeWaitProject(item)
                      this.reloadStatisticsOnly()
                      return
                    }

                    if (response.response_body.isStart === true) {
                      this.reLoad()
                      return
                    }
                  }

                  if (oprtype == 2) {
                    doctor.endtime = response.response_body.endTime

                    if (response.response_body.isEnd === true) {
                      Toast({
                        message: '加载中...',
                        type: 'loading',
                        duration: 0
                      })

                      this.reLoad()
                      return
                    }
                  }
                }else{
                  if (!response.response_body.issign){
                    Dialog.confirm({
                      title: '提示',
                      message: response.response_body.msg,
                      confirmButtonText: '去签名',
                      cancelButtonText: '取消'
                    })
                        .then(() => {
                          this.searchList(item)
                        })
                        .catch(() => {
                          // 点击取消，不做任何事
                        })
                  }else{
                    Toast.fail(response.response_body.msg)

                    setTimeout(() => {
                      this.reLoad();
                    }, 1000)
                  }
                }
              })

            },

            handleAcupointSave(newList) {
              if (!this.currentItemRef) return

              // 关键：直接覆盖 doctors
              this.$set(this.currentItemRef, 'doctorlist', newList)

              this.handleAcupointPlanSave()
            },
            /**
             * 记录配穴弹窗内已保存过方案或分工，等待关闭弹窗时统一刷新列表。
             */
            handleAcupointPlanSave() {
              this.acupointDialogNeedRefresh = true
            },
            /**
             * 处理配穴分工弹窗显示状态变化，仅保存过后关闭才刷新列表。
             */
            handleAcupointDialogVisibleChange(visible) {
              this.showAcupointDialog = visible

              if (visible || !this.acupointDialogNeedRefresh) {
                return
              }

              this.acupointDialogNeedRefresh = false
              this.reLoad()
            },

            //签名
            // 待签名服务查询  waitsignaturelist
            // 查询待签名列表
            searchList(item){
              console.log('item',item)
              let value = {
                username: this.username,
                serviceid: item.serviceid,
              };
              waitsignaturelist(value).then(res =>{

                const list = res && res.response_body ? res.response_body.list : []
                this.signaturelist = this.getValidSignatureList(list)

                this.changeRouter(item);
              })
            },
            // 获取待签名列表，接口未返回数组时按空列表处理，避免跳转前遍历报错
            getValidSignatureList(list) {
              return Array.isArray(list) ? list : []
            },
            /**
             * 保存当前理疗列表选中的 tab，用于从子页面返回后恢复原位置。
             */
            saveCurrentTreatTab(status) {
              sessionStorage.setItem('TREAT_PAGE_TAB', this.getValidQryStatus(status || this.qrystatus))
            },
            /**
             * 保存签名完成后的返回 tab，用于区分手动返回和保存成功返回。
             */
            saveSignatureSuccessReturnTab(status) {
              sessionStorage.removeItem('SIGNATURE_SUCCESS_RETURN_PATH')
              sessionStorage.setItem('SIGNATURE_SUCCESS_RETURN_TAB', this.getValidQryStatus(status || this.qrystatus))
            },
            /**
             * 恢复跳转前保存的理疗列表 tab，读取后立即清理，避免影响后续入口。
             */
            restoreTreatPageTab() {
              const treatPageTab = sessionStorage.getItem('TREAT_PAGE_TAB')
              if (!treatPageTab) {
                return
              }

              const lastTab = this.getValidQryStatus(treatPageTab)
              this.qrystatus = lastTab
              this.oldQrystatus = lastTab
              this.autoLoadWaitToEnd = lastTab === '2' && sessionStorage.getItem('TREAT_WAIT_LOAD_TO_END') === '1'
              sessionStorage.removeItem('TREAT_PAGE_TAB')
              sessionStorage.removeItem('SIGNATURE_SUCCESS_RETURN_TAB')
            },
            /**
             * 跳转签名页前分别保存手动返回 tab 和签名完成返回 tab。
             */
            goSignature(item, isAll, returnStatus, successReturnStatus) {
              const serviceid = this.getSignatureServiceId(item)
              if (!serviceid) {
                Toast.fail('暂无可签名项目')
                return
              }

              this.saveCurrentTreatTab(returnStatus)
              this.saveSignatureSuccessReturnTab(successReturnStatus || returnStatus)
              this.$router.push({
                path:'/signature',
                query:{
                  serviceid: serviceid,
                  isAll:isAll ? 'true' : 'false',
                }
              })
            },
            /**
             * 获取签名入口使用的服务ID，兼容患者维度聚合数据。
             */
            getSignatureServiceId(item) {
              if (!item) {
                return ''
              }

              if (item.serviceid) {
                return item.serviceid
              }

              if (item.allserviceid) {
                return (item.allserviceid + '').split(',').filter(id => id)[0] || ''
              }

              return ''
            },
            /**
             * 待分诊和待执行入口默认签署患者当天全部未签名项目，签名完成后统一回到待执行。
             */
            goAllSignature(item) {
              this.goSignature(item, true, this.qrystatus, this.qrystatus)
            },
            changeRouter(item){
              var arr = this.getValidSignatureList(this.signaturelist)

              console.log("item",item)
              let datas = arr.filter(vo => vo.id != item.serviceid).map(vo => vo.projectname )

              if(datas.length > 0){

                Dialog.confirm({
                  title: '提示',
                  message: `患者当天还存在其他理疗项目（${datas.join('、')}）未签名，是否同步签名`,
                  confirmButtonText:'全部签名',
                  cancelButtonText:'仅签名当前项目',
                })
                    .then(() => {
                      // on confirm
                      this.goSignature(item, true)
                    })
                    .catch(() => {
                      // on cancel
                      this.goSignature(item, false)
                    });
              }else{
                this.goSignature(item, false)
              }
            },
            onRefresh(status) {
              const refreshStatus = this.getValidQryStatus(status)
              // Pull refresh replaces pending work for the same tab.
              this.cancelLoadRequest()
              this.loading = false
              this.loadingStatus = ''

              this.qrystatus = refreshStatus
              this.oldQrystatus = refreshStatus

              this.resetCurrentTab(refreshStatus)

              this.onLoad()
            },
            resetCurrentTab(status) {
              const config = this.getTabConfig(status)
              this[config.finished] = false
              this[config.loading] = false
              this[config.count] = 0
              this[config.page] = 1
              this[config.list] = []
              this[config.isload] = false
              if (status === '2') {
                this.expandedWaitPatientKey = ''
                this.focusedWaitAcupointServiceId = ''
              }
            },
            setRefreshing(status, value) {
              const config = this.getTabConfig(status)
              this[config.refreshing] = value
            },
            /**
             * 初始化待执行患者项目数据，保证展开卡片中的配穴输入可以直接编辑。
             */
            normalizeWaitPatientList(list) {
              if (!Array.isArray(list)) {
                return []
              }

              return list.map(patient => {
                const projectlist = Array.isArray(patient.projectlist) ? patient.projectlist : []
                projectlist.forEach(project => {
                  this.$set(project, 'waitAcupointText', project.allpoints || '')
                })

                return patient
              })
            },
            /**
             * 获取待执行患者唯一标识，用于展开收起状态和列表渲染。
             */
            getWaitPatientKey(patient) {
              if (!patient) {
                return ''
              }

              return patient.userid + '_' + patient.customerid + '_' + (patient.allserviceid || '')
            },
            /**
             * 获取待执行患者下的项目列表，兼容接口异常返回。
             */
            getWaitProjectList(patient) {
              return patient && Array.isArray(patient.projectlist) ? patient.projectlist : []
            },
            /**
             * 设置待执行配穴输入框聚焦状态，用于高亮当前编辑项目。
             */
            setWaitAcupointFocus(project) {
              this.focusedWaitAcupointServiceId = project && project.serviceid ? project.serviceid + '' : ''
            },
            /**
             * 判断待执行配穴输入框是否为当前聚焦项目。
             */
            isWaitAcupointFocused(project) {
              return !!(project && project.serviceid && this.focusedWaitAcupointServiceId === project.serviceid + '')
            },
            /**
             * 清除待执行配穴输入框聚焦状态，保存成功后恢复默认边框。
             */
            clearWaitAcupointFocus(project) {
              if (!project || !project.serviceid || this.focusedWaitAcupointServiceId === project.serviceid + '') {
                this.focusedWaitAcupointServiceId = ''
              }
            },
            /**
             * 从待执行列表中移除已开始的项目，项目为空时同步移除患者卡片。
             */
            removeWaitProject(project) {
              if (!project || !project.serviceid) {
                return
              }

              const serviceId = project.serviceid + ''
              let nextExpandedKey = this.expandedWaitPatientKey
              const nextList = this.list2.map(patient => {
                const oldPatientKey = this.getWaitPatientKey(patient)
                const oldProjectList = this.getWaitProjectList(patient)
                const projectlist = oldProjectList.filter(item => {
                  return (item.serviceid + '') !== serviceId
                })

                if (projectlist.length === oldProjectList.length) {
                  return patient
                }

                const nextPatient = Object.assign({}, patient, {
                  projectlist: projectlist,
                  allserviceid: projectlist.map(item => item.serviceid).join(',')
                })

                if (nextExpandedKey === oldPatientKey) {
                  nextExpandedKey = projectlist.length ? this.getWaitPatientKey(nextPatient) : ''
                }

                return nextPatient
              }).filter(patient => this.getWaitProjectList(patient).length)

              this.list2 = nextList
              this.expandedWaitPatientKey = nextExpandedKey
            },
            /**
             * 从待执行列表中移除已全部开始的患者卡片。
             */
            removeWaitPatient(patient) {
              const waitPatientKey = this.getWaitPatientKey(patient)
              if (!waitPatientKey) {
                return
              }

              this.list2 = this.list2.filter(item => this.getWaitPatientKey(item) !== waitPatientKey)
              if (this.expandedWaitPatientKey === waitPatientKey) {
                this.expandedWaitPatientKey = ''
              }
            },
            /**
             * 切换待执行患者卡片展开状态。
             */
            toggleWaitPatient(patient) {
              const key = this.getWaitPatientKey(patient)
              this.expandedWaitPatientKey = this.expandedWaitPatientKey === key ? '' : key
            },
            /**
             * 判断待执行患者卡片是否处于展开状态。
             */
            isWaitPatientExpanded(patient) {
              return this.expandedWaitPatientKey === this.getWaitPatientKey(patient)
            },
            /**
             * 展开待执行列表最后一个患者卡片。
             */
            expandLastWaitPatient() {
              if (!this.list2.length) {
                return
              }

              this.expandedWaitPatientKey = this.getWaitPatientKey(this.list2[this.list2.length - 1])
            },
            /**
             * 计算待执行患者等待时长，按当前服务端时间减接口 exectime。
             */
            getWaitMinutesText(patient) {
              const exectime = this.getWaitPatientExecTime(patient)
              if (!exectime) {
                return '已等0分钟'
              }

              const execSeconds = this.getSeconds(exectime)
              if (!execSeconds) {
                return '已等0分钟'
              }

              const seconds = Math.floor(getServerNow() / 1000) - execSeconds
              const minutes = Math.max(Math.floor(seconds / 60), 0)
              return '已等' + minutes + '分钟'
            },
            /**
             * 获取患者维度等待开始时间，优先使用患者 exectime，兼容项目维度返回。
             */
            getWaitPatientExecTime(patient) {
              if (!patient) {
                return ''
              }

              if (patient.exectime) {
                return patient.exectime
              }

              const project = this.getWaitProjectList(patient).find(item => item.exectime)
              return project ? project.exectime : ''
            },
            /**
             * 获取待执行患者床位文案，使用患者字段或第一个有床位的项目字段。
             */
            getWaitPatientRoomText(patient) {
              const roomName = this.getWaitPatientRoomName(patient)
              return roomName ? '床位：' + roomName : '安排床位'
            },
            /**
             * 获取待执行患者当前床位名称。
             */
            getWaitPatientRoomName(patient) {
              if (!patient) {
                return ''
              }

              if (patient.roomname) {
                return patient.roomname
              }

              const project = this.getWaitProjectList(patient).find(item => item.roomname)
              return project ? project.roomname : ''
            },
            /**
             * 获取待执行患者当前床位 id。
             */
            getWaitPatientRoomId(patient) {
              if (!patient) {
                return ''
              }

              if (patient.roomid) {
                return patient.roomid
              }

              const project = this.getWaitProjectList(patient).find(item => item.roomid)
              return project ? project.roomid : ''
            },
            /**
             * 打开待执行患者床位弹窗，复用原床位安排逻辑。
             */
            openWaitBedPopup(patient) {
              const roomid = this.getWaitPatientRoomId(patient)
              const roomname = this.getWaitPatientRoomName(patient)
              const currentPatient = Object.assign({}, patient, {
                roomid: roomid,
                roomname: roomname
              })

              this.openBedPopup(currentPatient)
            },
            /**
             * 获取待执行项目的主理疗师，没有主理疗师时取第一位执行人。
             */
            getWaitProjectDoctor(project) {
              const doctorlist = project && Array.isArray(project.doctorlist) ? project.doctorlist : []
              if (!doctorlist.length) {
                return null
              }

              return doctorlist.find(doctor => doctor.ismain == 1) || doctorlist[0]
            },
            /**
             * 判断待执行项目主执行人与当前登录账号是否不一致。
             */
            isWaitProjectMainDoctorDiff(project) {
              const doctor = this.getWaitProjectDoctor(project)
              return !!(doctor && doctor.username && this.username && doctor.username != this.username)
            },
            /**
             * 主执行人不一致时弹出确认框，一致时直接继续执行。
             */
            confirmWaitDoctorBeforeStart(projectList, action) {
              const hasDiffDoctor = projectList.some(project => this.isWaitProjectMainDoctorDiff(project))
              if (!hasDiffDoctor) {
                action(0)
                return
              }

              this.waitDoctorConfirmAction = action
              this.showWaitDoctorConfirmDialog = true
            },
            /**
             * 关闭待执行主执行人确认框，并清理待执行操作。
             */
            closeWaitDoctorConfirmDialog() {
              this.showWaitDoctorConfirmDialog = false
              this.waitDoctorConfirmAction = null
            },
            /**
             * 按用户选择继续开始治疗，iseditdoctor 为 1 时后端同步修改主执行人。
             */
            confirmWaitDoctorStart(iseditdoctor) {
              const action = this.waitDoctorConfirmAction
              this.showWaitDoctorConfirmDialog = false
              this.waitDoctorConfirmAction = null

              if (action) {
                action(iseditdoctor)
              }
            },
            /**
             * 获取待执行项目当前输入的配穴方案，用于保存状态校验。
             */
            getWaitProjectInputAllPoints(project) {
              return project && project.waitAcupointText ? project.waitAcupointText.trim() : ''
            },
            /**
             * 开始待执行项目治疗，先保存配穴方案，再复用原医生治疗操作。
             */
            startWaitProject(project) {
              if (!this.validateWaitProjectSigned([project])) {
                return
              }

              const doctor = this.getWaitProjectDoctor(project)
              if (!doctor) {
                Toast.fail('请先添加执行人')
                return
              }

              if (!this.validateWaitAcupointCanSave([project])) {
                return
              }

              this.confirmWaitDoctorBeforeStart([project], (iseditdoctor) => {
                this.saveWaitAcupointPlanRequest(project, false).then(() => {
                  this.handleDoctorClick(doctor, project, 'waitStart', iseditdoctor)
                }).catch(() => {})
              })
            },
            /**
             * 开始待执行患者下的全部项目治疗，先逐项目保存配穴方案，再批量提交 serviceId 和 doctorlist 第一项 treatId。
             */
            startAllWaitProject(patient) {
              const projectList = this.getWaitProjectList(patient)
              if (!projectList.length) {
                Toast.fail('暂无可操作项目')
                return
              }

              if (!this.validateWaitProjectSigned(projectList)) {
                return
              }

              const projectDoctorList = projectList.map(project => {
                const doctorlist = Array.isArray(project.doctorlist) ? project.doctorlist : []
                return {
                  project: project,
                  doctor: doctorlist[0]
                }
              })
              const hasInvalidProject = projectDoctorList.some(item => {
                return !item.project.serviceid || !item.doctor || !item.doctor.treatid
              })

              if (hasInvalidProject) {
                Toast.fail('请先添加执行人')
                return
              }

              if (!this.validateWaitAcupointCanSave(projectList)) {
                return
              }

              this.confirmWaitDoctorBeforeStart(projectList, (iseditdoctor) => {
                this.startAllWaitProjectRequest(patient, projectList, projectDoctorList, iseditdoctor)
              })
            },
            /**
             * 提交待执行患者下全部项目开始治疗请求。
             */
            startAllWaitProjectRequest(patient, projectList, projectDoctorList, iseditdoctor) {
              Promise.all(projectList.map(project => this.saveWaitAcupointPlanRequest(project, false))).then(() => {
                wxoprtreat({
                  serviceId: projectDoctorList.map(item => item.project.serviceid).join(','),
                  treatId: projectDoctorList.map(item => item.doctor.treatid).join(','),
                  oprType: 1,
                  doctor: this.username,
                  iseditdoctor: iseditdoctor == 1 ? 1 : 0
                }).then((response) => {
                  if (response.response_body.flag) {
                    Toast.success('操作成功')
                    this.removeWaitPatient(patient)
                    this.reloadStatisticsOnly()
                  } else {
                    Toast.fail(response.response_body.msg)
                  }
                })
              }).catch(() => {})
            },
            /**
             * 获取待执行患者第一条项目，用于患者维度操作复用项目参数。
             */
            getFirstWaitProject(patient) {
              const list = this.getWaitProjectList(patient)
              return list.length ? list[0] : null
            },
            /**
             * 跳转待执行患者加项目页面，复用原分诊跳转逻辑。
             */
            goWaitPatientAssignTreat(patient) {
              const project = this.getFirstWaitProject(patient)
              if (!project) {
                Toast.fail('暂无可操作项目')
                return
              }

              const item = Object.assign({}, patient, {
                appointmentid: project.appointmentid || patient.appointmentid || '',
                roomid: this.getWaitPatientRoomId(patient),
                roomname: this.getWaitPatientRoomName(patient)
              })

              this.goAssignTreat(item, '2')
            },
            /**
             * 判断待执行患者是否存在未签名项目。
             */
            hasWaitUnsignedProject(patient) {
              return !!this.getFirstWaitUnsignedProject(patient)
            },
            /**
             * 获取待执行患者第一条未签名项目。
             */
            getFirstWaitUnsignedProject(patient) {
              return this.getWaitProjectList(patient).find(project => !project.signaturetime) || null
            },
            /**
             * 提示待执行患者未签名，并引导跳转全部项目签名。
             */
            showWaitUnsignedSignatureDialog(unsignedProject) {
              Dialog.confirm({
                title: '提示',
                message: '该患者还没有签名，请先签名后再开始执行',
                confirmButtonText: '去签名',
                cancelButtonText: '关闭'
              }).then(() => {
                this.goAllSignature(unsignedProject)
              }).catch(() => {
                // 点击关闭，不做任何事
              })
            },
            /**
             * 校验待执行项目是否已签名，未签名时阻断开始治疗。
             */
            validateWaitProjectSigned(projectList) {
              const unsignedProject = projectList.find(project => !project.signaturetime)
              if (unsignedProject) {
                this.showWaitUnsignedSignatureDialog(unsignedProject)
                return false
              }

              return true
            },
            /**
             * 校验待执行项目配穴方案是否满足保存条件，用于开始治疗前统一阻断异常数据。
             */
            validateWaitAcupointCanSave(projectList) {
              const noServiceProject = projectList.find(project => !project.serviceid)
              if (noServiceProject) {
                Toast.fail('缺少项目服务ID')
                return false
              }

              return true
            },
            /**
             * 保存待执行卡片内的配穴方案。
             */
            saveWaitAcupointPlan(project) {
              this.saveWaitAcupointPlanRequest(project, true).catch(() => {})
            },
            /**
             * 提交待执行项目配穴方案，供保存按钮和开始治疗前复用。
             */
            saveWaitAcupointPlanRequest(project, showSuccess) {
              if (!this.validateWaitAcupointCanSave([project])) {
                return Promise.reject({ handled: true })
              }

              const allPoints = this.getWaitProjectInputAllPoints(project)
              return wxsaveassignacupoint({
                serviceId: project.serviceid,
                allPoints: allPoints,
                oprType: '3',
                username: this.username
              }).then(response => {
                if (response.response_body.flag) {
                  if (showSuccess) {
                    Toast.success('保存成功')
                  }
                  this.$set(project, 'allpoints', allPoints)
                  this.$set(project, 'waitAcupointText', allPoints)
                  this.clearWaitAcupointFocus(project)
                  return true
                } else {
                  Toast.fail(response.response_body.msg || '保存失败')
                  return Promise.reject({ handled: true })
                }
              }).catch(error => {
                if (!error || !error.handled) {
                  Toast.fail('保存失败')
                }
                return Promise.reject(error)
              })
            },
            /**
             * 获取加项目进入分诊页时的理疗状态标记，执行中和已完成需要通知后端追加项目来源。
             */
            getAssignTreatStatus(){
              return ['3', '4'].indexOf(this.qrystatus + '') !== -1 ? '1' : '0'
            },
            goAssignTreat(item,oprtype){
              this.saveCurrentTreatTab()
              this.$store.dispatch('changeIsRefresh', '1')

              this.$router.push({
                path: '/assignTreat',
                query: {
                  userid: item.userid,
                  customerid: item.customerid,
                  name: item.name || '',
                  sex: item.sex || '',
                  age: item.age || '',
                  phone: item.phone || '',
                  appointmentid: item.appointmentid || '',
                  roomid: item.roomid || '',
                  roomname: item.roomname || '',
                  qryDate: this.date,
                  oprtype: oprtype || '2', // 1:转理疗分诊，2:直接分诊
                  treatstatus: this.getAssignTreatStatus(),
                }
              })
            },
            // 取消执行
            cancelProject(item){
              this.$dialog.confirm({
                title: null,
                message: '确认取消本次理疗？',
              })
                  .then(() => {
                    let data = {
                      username: this.username,
                      oprtype: '0',
                      serviceid: item.allserviceid
                    }
                    wxtreatopr(data).then(() => {
                      Toast.success('已成功取消本次理疗!');
                      this.onRefresh('5')
                    })
                  })
                  .catch(() => {
                    // on cancel
                  });
            },
            restartExec(item){
              // 二次确认
              Dialog.confirm({
                title: '提示',
                message: '重新开始会将项目重新计时，确认是否重新开始？',
                confirmButtonText: '确认',
                cancelButtonText: '取消'
              })
                  .then(() => {
                    // 点击确认才执行接口
                    wxrestarttreat({
                      serviceid: item.serviceid,
                      doctor: this.username
                    }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success('操作成功')
                        this.onRefresh('3')
                      }else{
                        Toast.fail(response.response_body.msg)
                      }
                    })
                  })
                  .catch(() => {
                    // 点击取消，不做任何事
                  })
          }
        },
    }
</script>

<style lang="scss" scoped>
    .van-info{
        top: 2px;
        right: -8px;
    }
    .van-cell{
        background-color: #F8F7FC;
        border-radius: 0.50667rem;
    }
    .bai {
        background-color: #ffffff;
    }
    .btnimg{
        width: 50px;
        height: 50px;
        position: fixed;
        right: 10px;
        bottom: 200px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .treat_main_list{
      padding: 0;
    }
    .treat_main_list .one{
        background: linear-gradient( 180deg, rgba(207,140,87,0.2) 0%, rgba(255,249,244,0) 20%);
        padding: 16px;
        border-radius: 12px;
        margin: 12px;
    }
    .wait-patient-card {
      position: relative;
      padding: 12px 14px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
    .treat_main_list .one.wait-patient-card {
      overflow: hidden;
      background: transparent;
    }
    .treat_main_list .one.wait-patient-card::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 170px;
      background: linear-gradient( 180deg, rgba(207,140,87,0.2) 0%, rgba(255,249,244,0) 20%);
      pointer-events: none;
    }
    .wait-patient-card > * {
      position: relative;
    }
    .wait-patient-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 28px;
      padding-bottom: 8px;
      border-bottom: 1px solid #f0f0f0;
    }
    .wait-patient-name {
      font-size: 0.4rem;
      font-weight: bold;
      color: #323333;
      word-break: break-all;
    }
    .wait-patient-bed {
      display: inline-flex;
      align-items: center;
      color: #CF8C57;
      font-size: 0.36rem;
      white-space: nowrap;
    }
    .wait-time {
      display: inline-flex;
      align-items: center;
      color: #999;
      font-size: 0.34rem;
      white-space: nowrap;
    }
    .wait-project-row {
      display: grid;
      grid-template-columns: 1fr 78px;
      align-items: center;
      column-gap: 10px;
      min-height: 38px;
      padding-top: 8px;
    }
    .wait-project-name {
      color: #323333;
      font-size: 0.38rem;
      font-weight: bold;
      line-height: 1.4;
      word-break: break-all;
    }
    .wait-start-btn,
    .wait-save-btn {
      height: 30px;
      padding: 0 10px;
      border-radius: 5px;
      font-size: 0.34rem;
      white-space: nowrap;
    }
    .wait-project-detail {
      border-bottom: 1px solid #f0f0f0;
    }
    .wait-project-detail:last-of-type {
      border-bottom: 0;
    }
    .wait-detail-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 8px;
      min-height: 28px;
      background: #f7f7f7;
      margin-top: 8px;
    }
    .wait-doctor-name {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      color: #323333;
      font-size: 0.34rem;
      white-space: nowrap;
    }
    .wait-acupoint-row {
      display: flex;
      align-items: flex-start;
      padding: 8px 0;
    }
    .wait-acupoint-label {
      width: 44px;
      color: #323333;
      font-size: 0.34rem;
      line-height: 30px;
      flex-shrink: 0;
    }
    .wait-acupoint-textarea {
      flex: 1;
      height: 58px;
      resize: none;
      border: 1px solid #e5e5e5;
      color: #323333;
      font-size: 0.34rem;
      line-height: 1.4;
      padding: 8px;
      box-sizing: border-box;
      background: #fff;
      outline: none;
    }
    .wait-acupoint-textarea-active {
      border-color: #CF8C57;
    }
    .wait-detail-actions,
    .wait-patient-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      column-gap: 10px;
    }
    .wait-patient-actions {
      padding-top: 8px;
    }
    .wait-link-btn {
      color: #323333;
      font-size: 0.36rem;
      padding: 6px 4px;
      white-space: nowrap;
    }
    .wait-doctor-confirm-dialog {
      width: 82%;
      max-width: 360px;
      border-radius: 8px;
    }
    .wait-doctor-confirm-title {
      color: #323333;
      font-size: 0.42rem;
      font-weight: bold;
      text-align: center;
    }
    .wait-doctor-confirm-content {
      padding: 18px 22px 8px;
      color: #323333;
      font-size: 0.38rem;
      line-height: 1.5;
      text-align: center;
    }
    .wait-doctor-confirm-actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 14px 20px 20px;
    }
    .wait-doctor-confirm-btn {
      width: 100%;
      height: 34px;
      border-radius: 5px;
      font-size: 0.36rem;
      white-space: normal;
    }
    .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }
    .patient-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .patient-name {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }
    .patient-detail {
        font-size: 14px;
        color: #666;
    }
    .card-middle {
        padding: 12px 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .project-name {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        flex: 1;
        margin-right: 12px;
    }
    .time-location {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        font-size: 14px;
        color: #666;
    }
    .card-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 12px;
    }
    .triage-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #CF8C57;
        font-size: 14px;
        cursor: pointer;
    }
    .bed-info {
        background: #CF8C57;
        color: #fff;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
    }
    .bed-dialog {
        width: 90%;
        max-width: 400px;
        border-radius: 12px;
    }
    .bed-dialog :deep(.van-dialog__header) {
        padding: 20px 20px 10px;
    }
    .dialog-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .dialog-title span:first-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .close-icon {
        font-size: 20px;
        color: #999;
        cursor: pointer;
        line-height: 1;
    }
    .bed-dialog :deep(.van-dialog__content) {
        max-height: 70vh;
        overflow-y: auto;
    }
    .bed-popup {
        padding: 10px 0 0;
    }
    .patient-info-section {
        background: #CF8C57;
        border-radius: 5px;
        padding: 8px 10px;
        margin: 0 20px 24px;
    }
    .patient-header {
        font-size: 20px;
        color: #fff;
    }
    .patient-detail {
        font-size: 16px;
        color: #fff;
    }
    .bed-section {
        padding: 0 20px;
    }
    .section-title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 16px;
    }
    .bed-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }
    .bed-item {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        padding: 5px;
        flex-direction: column;
    }
    .bed-occupied {
        background: #ddd;
        color: #999;
        cursor: pointer;
    }
    .bed-available {
        background: #fff;
        border: 1px solid #CF8C57;
        color: #CF8C57;
    }
    .bed-selected {
        background: #CF8C57 !important;
        color: #fff !important;
        border: 1px solid #CF8C57;
    }
    .confirm-section {
        padding: 20px;
    }
    .confirm-btn {
        width: 100%;
        height: 50px;
        background: #CF8C57;
        color: #fff;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 600;
    }

    .point-text {
      color: #999;
      margin-left: 4px;
    }


    .doctor-left {
      width: 75% !important;
      word-break: break-all;
      white-space: normal !important;
      line-height: 1.4;
    }

    .execute-doctor-row .doctor-left {
      width: calc(100% - 94px) !important;
    }

    .doctor-right {
      width: 25% !important;
      text-align: center !important;
      border-radius: 8px;
      padding: 5px;
    }

    .execute-status-btn,
    .acupoint-assign-btn {
      width: 84px !important;
      box-sizing: border-box;
    }

    .execute-status-btn {
      flex-shrink: 0;
    }

    .acupoint-assign-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 32px;
      background-color: #CF8C57;
      text-align: center;
      color: #fff;
      border-radius: 6px;
      font-size: 0.36rem;
      padding: 5px 0;
      white-space: nowrap;
    }

    .main-tag {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background: #CF8C57; /* 土黄 */
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      margin-right: 6px;
      flex-shrink: 0;
    }

    /* 已完成：灰底灰字 */
    .status-finished {
      background: #f2f2f2;
      color: #999;
      padding: 2px;
    }

    /* 未开始 + 执行中：土黄底白字 */
    .status-active {
      background: #CF8C57;
      color: #fff;
      padding: 2px;
    }

    /* 时间 */
    .time {
      font-size: 14px;
    }

    /* 状态文字 */
    .status-text {
      font-size: 14px;
    }

    .freeRoom{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .freeRoom img{
      width: 30px;
    }

    .page-loading {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 9999;
      background: rgba(255, 255, 255, 0.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .title_top_text{
      margin-top: 8px;
      margin-bottom: 8px !important;
    }
    .feedback-icon{

    }
</style>
